module.exports = __webpack_public_path__ + "media/svg-new/sad-5b34baa4.svg";